export { default as EntityCard } from './EntityCard'
